import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { AppState } from '../../types';
import { FirebaseReducer, isLoaded } from 'react-redux-firebase';
import ComponentLoading from './ComponentLoading';

const propTypes = {};

const defaultProps = {};

type Props = {
  children: any;
};

export default function AuthIsLoaded({ children }: Props) {
  const auth = useSelector<AppState, FirebaseReducer.AuthState>
    (state => state.firebase.auth);
  return isLoaded(auth) ? children : <ComponentLoading />;
}

AuthIsLoaded.propTypes = propTypes;
AuthIsLoaded.defaultProps = defaultProps;